import { deleteEvent, updateEvent } from '../../services/eventService';
import { updateCalculs } from '../../services/calculService';
import { getSalaire, saveSalaire } from '../../services/salaireService';
import { formatDateForDisplay } from '../../ui-tools/dateUtils';
import { showDateEditModal } from './DateEditModal';
import { initEventList } from './index';

// Fonction mise à jour pour créer un élément événement avec les nouvelles classes
export async function createEventElement(event) {
  const eventElement = document.createElement('div');
  eventElement.className = 'event-item';

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const eventEndDate = new Date(event.endDate);
  eventEndDate.setHours(0, 0, 0, 0);

  // Déterminer si l'événement est passé (basé sur la date de fin)
  const isPast = eventEndDate < today;
  const isFuture = !isPast;

  // Mapper les valeurs des statuts aux classes CSS
  const statusClassMap = {
    'ok': 'status-ok',
    'option+': 'status-option-plus',
    'option-': 'status-option-moins'
  };

  // Icônes Font Awesome pour les statuts
  const statusIcons = {
    'ok': '<i class="fas fa-check-circle"></i>',
    'option+': '<i class="fas fa-question-circle"></i>',
    'option-': '<i class="fas fa-times-circle"></i>'
  };

  // Créer l'élément d'événement avec la classe mappée
  const statusClass = statusClassMap[event.status] || '';
  eventElement.className = `event-item ${statusClass}${isPast ? ' past' : ''}${event.isInPeriod ? ' in-period' : ''}`;
  eventElement.dataset.id = event.id;
  eventElement.dataset.status = event.status;

  // Formater les dates pour l'affichage
  const startDate = new Date(event.startDate);
  const endDate = new Date(event.endDate);
  const formattedStartDate = formatDateForDisplay(startDate);
  const formattedEndDate = formatDateForDisplay(endDate);

  // Déterminer si c'est un événement d'une journée
  const isSameDay = startDate.toDateString() === endDate.toDateString();

  // *** LIGNE DU HAUT : Dates - Status - Heures ***
  const headerTop = document.createElement('div');
  headerTop.className = 'event-header-top';

  // Date de l'événement (à gauche)
  const dateTop = document.createElement('span');
  dateTop.className = 'event-date-top';
  const iconCalendarLocation = '/images/simple-calendar-icon-0.svg';

  if (isSameDay) {
    // Événement d'un seul jour
    dateTop.innerHTML = `
      <div class="calendar-icon">
        <img src="${iconCalendarLocation}" class="calendar-bg" alt="Calendrier">
        <span class="calendar-date">${formattedStartDate}</span>
      </div>
    `;
  } else {
    // Événement sur plusieurs jours - calculer le nombre de jours
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

    dateTop.innerHTML = `
      <div class="calendar-icon">
        <img src="${iconCalendarLocation}" class="calendar-bg" alt="Calendrier">
        <span class="calendar-date">${formattedStartDate}</span>
      </div>
      <div class="date-arrow-container">
        <span class="days-count">${daysDiff}</span>
        <span class="date-arrow">&rarr;</span>
      </div>
      <div class="calendar-icon">
        <img src="${iconCalendarLocation}" class="calendar-bg" alt="Calendrier">
        <span class="calendar-date">${formattedEndDate}</span>
      </div>
    `;
  }

  headerTop.appendChild(dateTop);

  // Contrôles de l'en-tête (au centre et à droite)
  const headerControls = document.createElement('div');
  headerControls.className = 'event-header-controls';

  // Section du statut (au milieu)
  const statusSection = document.createElement('div');
  statusSection.className = 'event-header-status';

  const statusSelect = document.createElement('select');
  statusSelect.className = 'event-status-select';
  statusSelect.id = `event-status-${event.id}`;
  statusSelect.name = `event-status-${event.id}`;

  const options = [
    { value: 'ok', text: 'Confirmé', selected: event.status === 'ok' },
    { value: 'option+', text: 'Option+', selected: event.status === 'option+' },
    { value: 'option-', text: 'Option-', selected: event.status === 'option-' }
  ];

  if (isPast) {
    // Pour les événements passés : seulement "Confirmé" et "Supprimer"
    const pastOptions = [
      { value: 'ok', text: 'Confirmé', selected: true },
      { value: 'delete', text: 'Supprimer', selected: false }
    ];

    pastOptions.forEach(opt => {
      const option = document.createElement('option');
      option.value = opt.value;
      option.textContent = opt.text;
      option.selected = opt.selected;
      statusSelect.appendChild(option);
    });
  } else {
    options.push({ value: 'delete', text: 'Supprimer', selected: false });

    options.forEach(opt => {
      const option = document.createElement('option');
      option.value = opt.value;
      option.textContent = opt.text;
      if (opt.selected) option.selected = true;
      statusSelect.appendChild(option);
    });
  }

  const statusIcon = document.createElement('span');
  statusIcon.className = 'status-icon';
  statusIcon.innerHTML = statusIcons[event.status] || '';
  statusSection.appendChild(statusIcon);
  statusSection.appendChild(statusSelect);
  headerControls.appendChild(statusSection);

  // Section des heures (à droite)
  const hoursSection = document.createElement('div');
  hoursSection.className = 'event-header-hours';

  // const hoursLabel = document.createElement('label');
  // hoursLabel.textContent = 'Heures :';
  // hoursLabel.className = 'event-hours-label';
  // hoursLabel.htmlFor = `event-hours-${event.id}`;
  // hoursSection.appendChild(hoursLabel);

  const hoursInput = document.createElement('input');
  hoursInput.type = 'number';
  hoursInput.className = 'event-hours-input';
  hoursInput.value = event.hours || '0';
  hoursInput.min = '0';
  hoursInput.step = '1';
  hoursInput.max = '999';
  hoursInput.id = `event-hours-${event.id}`;
  hoursInput.name = `event-hours-${event.id}`;
  hoursInput.autocomplete = 'off';
  hoursInput.placeholder = '0';

  const hoursWrapper = document.createElement('div');
  hoursWrapper.className = 'hours-input-wrapper';
  hoursWrapper.appendChild(hoursInput);

  hoursSection.appendChild(hoursWrapper);
  headerControls.appendChild(hoursSection);

  headerTop.appendChild(headerControls);
  eventElement.appendChild(headerTop);

  // *** LIGNE INTERMÉDIAIRE : Salaire tout à droite ***
  const salaireRow = document.createElement('div');
  salaireRow.className = 'event-salaire-row';

  const salaireSection = document.createElement('div');
  salaireSection.className = 'event-header-salaire';

  // const salaireLabel = document.createElement('label');
  // salaireLabel.textContent = 'Salaire :';
  // salaireLabel.className = 'event-salaire-label';
  // salaireLabel.htmlFor = `event-salaire-${event.id}`;
  // salaireSection.appendChild(salaireLabel);

  const salaireInput = document.createElement('input');
  salaireInput.type = 'number';
  salaireInput.className = 'event-salaire-input';
  salaireInput.id = `event-salaire-${event.id}`;
  salaireInput.name = `event-salaire-${event.id}`;
  salaireInput.min = '0';
  salaireInput.step = '0.01';
  salaireInput.placeholder = '0';

  // Charger la valeur stockée
  getSalaire(event.id).then(val => {
    salaireInput.value = val || '';
  });

  // Sauvegarder à la modification
  salaireInput.addEventListener('change', async () => {
    await saveSalaire(event.id, salaireInput.value);
    await updateCalculs();
  });

  salaireSection.appendChild(salaireInput);
  salaireRow.appendChild(salaireSection);
  eventElement.appendChild(salaireRow);

  // *** DERNIÈRE LIGNE : Titre ***
  const titleInput = document.createElement('input');
  titleInput.type = 'text';
  titleInput.className = 'event-title-input';
  titleInput.value = event.title || '';
  titleInput.placeholder = 'Sans titre';
  titleInput.id = `event-title-${event.id}`;
  titleInput.name = `event-title-${event.id}`;

  eventElement.appendChild(titleInput);

  // Attacher les écouteurs d'événements
  attachEventListeners(eventElement, event);

  return eventElement;
}

// Fonction pour attacher les écouteurs d'événements à un élément événement
function attachEventListeners(eventElement, event) {
  // ✅ SOLUTION : Vérifier avant d'attacher
  if (eventElement.hasAttribute('data-listeners-attached')) {
    return; // Déjà initialisé
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const eventEndDate = new Date(event.endDate);
  eventEndDate.setHours(0, 0, 0, 0);

  const isPast = eventEndDate < today;

  // Écouteur pour le changement de statut - pour tous les événements (passés et futurs)
  // Appliquer la classe appropriée si la valeur actuelle est "delete"
  const statusSelect = eventElement.querySelector(`#event-status-${event.id}`);

  if (statusSelect.value === 'delete') {
    statusSelect.classList.add('delete-option-selected');
  }

  statusSelect.addEventListener('change', async () => {
    const selectedValue = statusSelect.value;

    // Appliquer ou retirer la classe pour l'option "Supprimer"
    if (selectedValue === 'delete') {
      statusSelect.classList.add('delete-option-selected');
    } else {
      statusSelect.classList.remove('delete-option-selected');
    }

    // Si "Supprimer" est sélectionnée
    if (selectedValue === 'delete') {
      if (confirm('Êtes-vous sûr de vouloir supprimer cet événement ?')) {
        await deleteEvent(event.id);
        await initEventList();
        await updateCalculs();
      } else {
        // Restaurer la valeur précédente si l'utilisateur annule
        statusSelect.value = event.status;
        statusSelect.classList.remove('delete-option-selected');
      }
    } else {
      // Pour les autres statuts, mettre à jour l'événement
      if (selectedValue !== 'delete') {
        try {
          if (!event || !event.id) {
            console.error('Événement invalide:', event);
            throw new Error('Impossible de mettre à jour un événement sans ID');
          }

          const updatedEvent = { ...event, status: selectedValue };
          await updateEvent(updatedEvent.id, updatedEvent);
          event.status = selectedValue;

          // Mise à jour des classes CSS
          eventElement.classList.remove('status-ok', 'status-option-plus', 'status-option-moins');

          let newStatusClass;
          switch (selectedValue) {
            case 'ok':
              newStatusClass = 'status-ok';
              break;
            case 'option+':
              newStatusClass = 'status-option-plus';
              break;
            case 'option-':
              newStatusClass = 'status-option-moins';
              break;
            default:
              newStatusClass = '';
          }

          if (newStatusClass) {
            eventElement.classList.add(newStatusClass);
          }
          eventElement.dataset.status = selectedValue;

          // Mettre à jour l'icône
          const statusIcon = eventElement.querySelector('.status-icon');
          const statusIcons = {
            'ok': '<i class="fas fa-check-circle"></i>',
            'option+': '<i class="fas fa-question-circle"></i>',
            'option-': '<i class="fas fa-times-circle"></i>'
          };
          statusIcon.innerHTML = statusIcons[selectedValue] || '';

          await updateCalculs();
        } catch (error) {
          console.error('Erreur lors de la mise à jour du statut:', error);
        }
      }
    }
  });

  // Écouteur pour l'édition des dates via la date affichée en haut
  const dateTopElement = eventElement.querySelector('.event-date-top');
  dateTopElement.addEventListener('click', () => {
    showDateEditModal(event);
  });

  // Écouteur pour le changement des heures
  const hoursInput = eventElement.querySelector(`#event-hours-${event.id}`);

  // REMPLACEZ par un seul écouteur
  hoursInput.addEventListener('change', async () => {
    let newHours = parseInt(hoursInput.value) || 0;

    if (newHours < 0) newHours = 0;
    if (newHours > 999) newHours = 999;

    hoursInput.value = newHours;

    if (newHours !== event.hours) {
      const updatedEvent = { ...event, hours: newHours };
      await updateEvent(updatedEvent.id, updatedEvent);
      event.hours = newHours;
      await updateCalculs();
    }
  });

  // Écouteur pour le changement de l'intitulé
  const titleInput = eventElement.querySelector(`#event-title-${event.id}`);
  titleInput.addEventListener('change', async () => {
    const newTitle = titleInput.value.trim();

    // Validation du titre
    if (!newTitle) {
      titleInput.value = event.title;
      return;
    }

    const updatedEvent = { ...event, title: newTitle };
    // Correction ici aussi : passer l'ID comme premier paramètre
    await updateEvent(updatedEvent.id, updatedEvent);

    // Mise à jour de la référence locale
    event.title = newTitle;

    await updateCalculs(); // Mise à jour au cas où cela affecterait les calculs
  });

  // Marquer comme initialisé
  eventElement.setAttribute('data-listeners-attached', 'true');
}